<template>
  <BForm @submit.prevent>
    <BRow>
      <BCol md="12">
        <BaseInput
          v-model="localValue.districtName"
          label="地区名"
          type="text"
          placeholder="例: 中央地区、東部地区"
          :maxlength="20"
          :required="true"
          :error-message="errors.districtName"
          @input="handleInput"
        />
      </BCol>
    </BRow>

    <div class="text-muted small mt-3">
      <i class="bi bi-info-circle me-1"></i>
      * の項目は必須入力です。
    </div>
  </BForm>
</template>

<script setup>
import { computed } from 'vue'
import { BForm, BRow, BCol } from 'bootstrap-vue-next'
import BaseInput from '@/components/atoms/BaseInput.vue'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  errors: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['update:modelValue'])

const localValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})

const handleInput = () => {
  // 入力が変更された時に親コンポーネントに通知
  emit('update:modelValue', localValue.value)
}
</script>

<style scoped>
.form-label {
  font-weight: 500;
  color: #495057;
  margin-bottom: 0.5rem;
}
</style>
